import KanbanContainer from './KanbanContainer';
export default KanbanContainer;



// WEBPACK FOOTER //
// ./src/containers/Kanban/index.js